import React, {useState, useEffect} from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap';
import {textTruncateByLength} from 'utils/other';
import {toast} from 'react-toastify';
import {assignAlertToUsers} from 'utils/api';
import DualSelect from 'components/DualSelect';
import SpinnerButton from 'components/SpinnerButton';
// import DualListBox from 'components/DualListBox/index';
//import './style.scss';


const AssignSavedSearchModal = (props) => {
    const {savedSearch, alertType, isOpen, toggle, users, handleAssignAlert, assigningSavedSearch} = props;
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        setSelectedUsers(props.selectedList)
    }, [])

    const handleSubmit = async() => {
        try {
            let selectedUserIds = selectedUsers.map(user => user.id);
            handleAssignAlert(savedSearch.id, selectedUserIds, alertType)
            toast.success('Alert successfully assigned');
            toggle();
        } catch(err) {
            console.log(err);
        }
    }

    return (
        <Modal isOpen={isOpen} toggle={toggle} className="feeds-select-modal" style={{width: '80%', maxWidth: 'none'}}>
            <ModalHeader toggle={toggle}>
                <strong>{alertType === 'daily' ? 'Assign Daily Alert' : 'Assign Real Time Alert'}</strong>
            </ModalHeader>
            <ModalBody>
                <div>Saved Search Name: {textTruncateByLength(savedSearch.sourceName, 50)}</div>
                <div style={{fontSize: '17.5px', fontWeight: '700', margin: '10px 0'}}>Select Users</div>
                {/*<DualListBox*/}
                {/*    getSelected={setSelectedItems}*/}
                {/*    options={users}*/}
                {/*    selected={selectedItems}*/}
                {/*    largeBoxes={true}*/}
                {/*    searchPlaceholder="Search by user name"*/}
                {/*/>*/}
                <DualSelect
                    selectedList={selectedUsers}
                    fullList={users}
                    // groups={userGroups}
                    onSelect={setSelectedUsers}
                    contentType="users"
                    largeBoxes
                />
            </ModalBody>
            <ModalFooter className="select-fetches-modal-footer">
                <Button style={{color: 'white'}} onClick={toggle}>
                    Cancel
                </Button>
                <SpinnerButton
                    style={{minWidth: '80px', marginLeft: '10px'}}
                    // disabled={searchValue.length > 990}
                    onClick={handleSubmit}
                    className="btn calltoaction-button"
                    submitting={assigningSavedSearch}
                    title="Assign"
                />
            </ModalFooter>
        </Modal>
    );
};

export default AssignSavedSearchModal;

//
//
// class SelectFetchesModal extends Component {
//     state = {
//         selectedItems: [],
//         submitLoading: false,
//     }
//
//     componentDidMount() {
//         this.setState({ selectedItems: this.props.selectedOptions });
//     }
//
//     submitUsersSelection(selectedItems) {
//         this.setState({ submitLoading: true })
//         const params = {
//             users: selectedItems.map(item => item.id),
//             flag: this.props.alertType === 'Daily' ? 'daily' : this.props.alertType === 'RT' ? 'hourly' : false,
//         }
//         if(this.props.alertType === 'Daily') {
//             assignDailyUsersToSearch(this.props.savedSearch.id, params)
//                 .then((data) => {
//                     this.setState({ submitLoading: false });
//                     this.props.submit(this.props.savedSearch.id, selectedItems);
//                 })
//                 .catch((err) => {
//                     if(err.message && err.message.length < 150) {
//                         toast.error(err.message);
//                     }
//                     this.setState({ submitLoading: false });
//                 });
//         } else if(this.props.alertType === 'RT') {
//             assignRTUsersToSearch(this.props.savedSearch.id, params)
//                 .then((data) => {
//                     this.setState({ submitLoading: false });
//                     this.props.submit(this.props.savedSearch.id, selectedItems);
//                 })
//                 .catch((err) => {
//                     if(err.message && err.message.length < 150) {
//                         toast.error(err.message);
//                     }
//                     this.setState({ submitLoading: false });
//                 });
//         }
//     }
//
//     getSelected = (selectedItems) => {
//         this.setState({selectedItems})
//     };
//
//     render() {
//         const { selectedItems, submitLoading } = this.state;
//         const { list } = this.props;
//         return (
//             <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} className="feeds-select-modal">
//                 <ModalHeader toggle={this.props.toggle}>
//                     <strong>{this.props.alertType === 'Daily' ? 'Assign Daily Alert' : 'Assign Real Time Alert'}</strong>
//                 </ModalHeader>
//                 <ModalBody>
//                     <div>Saved Search Name: {textTruncateByLength(this.props.savedSearch.title, 50)}</div>
//                     <div style={{ fontSize: '17.5px', fontWeight: '700', margin: '10px 0'  }}>Select Users</div>
//                     <DualListBox
//                         getSelected={this.getSelected}
//                         options={list}
//                         selected={selectedItems}
//                         largeBoxes={true}
//                         searchPlaceholder="Search by user name"
//                     />
//                 </ModalBody>
//                 <ModalFooter className="select-fetches-modal-footer">
//                     <Button style={{ color: 'white' }} onClick={this.props.toggle}>
//                         Cancel
//                     </Button>
//                     <Button
//                         style={{ minWidth: '83.64px' }}
//                         onClick={!submitLoading ? () => this.submitUsersSelection(selectedItems) : () => {}}
//                         className="btn calltoaction-button"
//                     >
//                         {submitLoading ?
//                             <i className="fa fa-spinner fa-spin" />
//                             :
//                             'Assign'
//                         }
//                     </Button>
//                 </ModalFooter>
//             </Modal>
//         );
//     }
// }
//
// export default SelectFetchesModal;